"use client";

/**
 * NewForm DS hover icon — two stacked sheets for "copy".
 * On hover the front sheet slides clear of the one behind it, the gesture
 * of peeling a duplicate off a stack.
 * See ./hoverIcon for the colour/animation conventions.
 */

import { type HoverIconProps, HoverIconSvg } from "./hoverIcon";

export function CopyIcon({ size, className }: HoverIconProps) {
  return (
    <HoverIconSvg size={size} className={className}>
      <path d="M4.4 15.8A2.2 2.2 0 0 1 2.2 13.6V4.4a2.2 2.2 0 0 1 2.2-2.2h9.2a2.2 2.2 0 0 1 2.2 2.2" />
      <rect
        className="g a-peel"
        x="8.2"
        y="8.2"
        width="13.6"
        height="13.6"
        rx="2.4"
      />
    </HoverIconSvg>
  );
}
